// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"451699f0","285":"6d864f3c","351":"832d4e4d","392":"9732a89a","562":"0af2cfc7","675":"5222ab06","848":"71e3c48d","880":"aa6e48b7","937":"8aa2202e"}[chunkId] + ".chunk.js";
};